import React from "react";

import Carousel from "components/common/Carousel";
import SectionWithImage from "components/common/SectionWithImage";
import SectionTextBlock from "components/common/SectionTextBlock";

import envs from "config/envs";

import * as S from "./SectionSupportedInitiatives.Style";

const supportedInitiativesList = [
  {
    id: 7,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/uma-noite-com-os-impressionistas-image.webp`,
    title: "Uma Noite com os Impressionistas",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          A mostra imersiva “Uma Noite com os Impressionistas” transporta o
          público em São Paulo para a Paris de 1874, recriando a primeira
          exposição impressionista da história. Com óculos de realidade virtual,
          os visitantes caminham por ambientes históricos e vivenciam a
          atmosfera que marcou o nascimento do movimento artístico.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Bonfilm Produção e
          Distribuição Audiovisual LTDA
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jun/2024 a fev/2026
        <br /> Investimento: R$ 500.000,00 (27/06/2025), R$ 500.000,00
        (08/07/2025), R$ 500.000,00 (09/09/2025) e R$ 500.000,00 (01/10/2025)
        <br /> PRONAC Nº 234671
      </>
    ),
  },
  {
    id: 6,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/andy-warhol-pop-art-image.webp`,
    title: "Andy Warhol Pop Art!",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          A maior exposição já realizada no Brasil sobre o artista, com mais de
          600 obras originais. Em 2025, integrou o plano anual de atividades do
          Museu de Arte Brasileira/FAAP, que contempla: exposições temporárias,
          programa cultural, programa educativo e de acessibilidade.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Instituto Totex
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jan/2025 a dez/2025
        <br /> Investimento: R$ 1.270.000,00 (30/12/2024) e R$ 1.730.000,00
        (11/03/2025)
        <br /> PRONAC Nº 245768
      </>
    ),
    count: (
      <>
        <span>328 mil</span> VISITANTES
      </>
    ),
  },
  {
    id: 5,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Instituto/Images/programs-jovem-expressao-image.webp`,
    title: "Jovem de Expressão",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          Focado em jovens entre 18 e 29 anos, o programa atua em quatro eixos:
          cultura, educação, empreendedorismo e saúde mental. As atividades
          ocorrem na Praça do Cidadão, em Ceilândia — região administrativa mais
          populosa do Distrito Federal.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Instituto de Referência da
          Juventude
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jan/2025 a dez/2026
        <br /> Investimento: R$ 980.405,00 (31/12/2024)
        <br /> PRONAC Nº 243548
      </>
    ),
    count: (
      <>
        <span>+7 mil</span> JOVENS IMPACTADOS
      </>
    ),
  },
  {
    id: 1,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/libraries-image.webp`,
    title: "Lab Bibliotecas Renato Russo",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          O projeto reforma e equipa bibliotecas de escolas públicas do ensino
          médio em Ceilândia, com novos livros, computadores e mobiliários,
          tornando o ambiente mais atrativo para os estudantes. No primeiro ano
          do projeto, são oferecidas diversas atividades pedagógicas, como
          oficinas profissionalizantes, para ampliar o acesso à cultura e gerar
          oportunidades futuras para os jovens.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Associação Amigos da Vida
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jan/2024 a março/2025 <br /> Investimento: R$
        499.923,60 (27/02/2024) <br /> PRONAC Nº 223352
      </>
    ),
    count: (
      <>
        <span>2,9 mil</span> alunos beneficiados em 2024
      </>
    ),
  },
  {
    id: 2,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/cinema-image.webp`,
    title: "Cinema em Movimento",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          Este projeto leva filmes da recente produção nacional às salas de
          aula, focando em direitos humanos e oferecendo material pedagógico
          para professores. Além disso, inclui oficinas para alunos discutirem
          sonhos e desafios, promovendo cultura e conhecimento. A iniciativa já
          beneficiou 60 escolas públicas e impactou cerca de 20 mil estudantes.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Meios de Produção e
          Comunicação LTDA.
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jan/2024 a jan/2026
        <br /> Investimento: R$ 997.708,96 (30/04/2024)
        <br /> PRONAC Nº 234910
      </>
    ),
    count: (
      <>
        <span>20 mil</span> ESTUDANTES IMPACTADOS
      </>
    ),
  },
  {
    id: 3,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/education-image.webp`,
    title: "O Futuro do Agora - Um Olhar Sobre a Educação",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          O documentário "O Futuro do Agora", produzido pela MPC Filmes, aborda
          os desafios da educação no Brasil. De forma franca e direta, revela
          problemas estruturais que já eram preocupantes antes da pandemia e que
          se agravaram nos últimos anos.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Meios de Produção e
          Comunicação LTDA.
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: jan/2023 a dezembro/2025
        <br /> Investimento: R$ 567.172,54 (23/02/2024)
        <br /> PRONAC Nº 212891
      </>
    ),
  },
  {
    id: 4,
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/dali-savior-image.webp`,
    title: "Desafio Salvador Dalí",
    subtitle: (
      <>
        Ação apoiada pela nossa subsidiária{" "}
        <strong>Caixa Seguradora S.A.</strong>
      </>
    ),
    description: (
      <>
        <p>
          Exposição de artes visuais baseada na produção artística e na vida do
          pintor e multiartista Salvador Dalí. Ocorreu em um momento propício
          para celebrar os 100 anos do movimento surrealista e proporcionou um
          programa educativo para estudantes e público em geral.
        </p>

        <p>
          <strong>Responsável pelo projeto:</strong> Conteúdo Criativo Produções
          Artísticas LTDA.
        </p>
      </>
    ),
    footer: (
      <>
        Prazo de execução: fev/2024 a nov/2024
        <br /> Investimento: R$ 1.800.000,00 (26/04/2024) e R$ 1.200.000,00
        (27/05/2024)
        <br /> PRONAC Nº 234671
      </>
    ),
    count: (
      <>
        <span>200 mil</span> Visitantes
      </>
    ),
  },
];

const SectionSupportedInitiatives = () => {
  return (
    <S.SectionSupportedInitiativesContainer>
      <S.SectionSupportedInitiativesContent className="container">
        <S.SectionSupportedInitiativesTitle>
          Iniciativas apoiadas
        </S.SectionSupportedInitiativesTitle>

        <Carousel numberOfSlidersToDisplay={1}>
          {supportedInitiativesList.map((supportedInitiativesItem) => (
            <div key={supportedInitiativesItem?.id}>
              <SectionWithImage
                noContainer
                src={supportedInitiativesItem.image}
                alt={supportedInitiativesItem.alt}
                reverse
              >
                <SectionTextBlock
                  border
                  title={supportedInitiativesItem.title}
                  subtitle={supportedInitiativesItem.subtitle}
                  description={supportedInitiativesItem.description}
                />
              </SectionWithImage>

              <S.SectionSupportedInitiativesFooter>
                {supportedInitiativesItem.footer}
              </S.SectionSupportedInitiativesFooter>

              {supportedInitiativesItem?.count && (
                <S.SectionSupportedInitiativesCount>
                  {supportedInitiativesItem?.count}
                </S.SectionSupportedInitiativesCount>
              )}
            </div>
          ))}
        </Carousel>
      </S.SectionSupportedInitiativesContent>
    </S.SectionSupportedInitiativesContainer>
  );
};

export default SectionSupportedInitiatives;
